"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteredPatientChatsContext = void 0;
const react_1 = require("react");
exports.FilteredPatientChatsContext = (0, react_1.createContext)({});
